import gql from "graphql-tag";

export default gql`
mutation($id: Int!){
    deleteGear(
        id: $id
    )
  }    
` 